import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { FractalContainer } from './fractal.styles';
import ImageCards from './Cards/ImageCards';
import TextCards from './Cards/TextCards';
import PodCasts from './Cards/PodCasts';
import JobPostings from './Cards/JobPostings';
import { BackwardFractalCarousel, ForwardFractalCarousel } from '../../icons';
import useScreenSize from '../../../../../Hooks/DeviceScreenSize/index';
import useScreenType from '../../../../../Hooks/DeviceType';
const FractalResponse = ({ details, submitChat, form }) => {
	const [imageCards, setImageCards] = useState([]);
	const [videoCards, setVideoCards] = useState([]);
	const [podCast, setPodCast] = useState([]);
	const [textCards, setTextCards] = useState([]);
	const [jobPostings, setJobPostings] = useState([]);
	const [selectedItem, setSelectedItem] = useState(0);
	const screenSize = useScreenSize();
	const deviceType = useScreenType();

	useEffect(() => {
		if (details.length > 0) {
			let images = details.filter((data) => data.type === 'images');
			setImageCards(images);
			let videos = details.filter((data) => data.type === 'videos');
			setVideoCards(videos);
			let podCast = details.filter((data) => data.type === 'podCast');
			setPodCast(podCast);
			let text = details.filter((data) => data.type === 'text');
			setTextCards(text);
			let jobPostings = details.filter((data) => data.type === 'jobposting');
			setJobPostings(jobPostings);
		}
	}, []);

	const percentageCalculator = () => {
		if (screenSize === 425) {
			return 63;
		} else if (screenSize === 768) {
			return 45;
		}
		if (deviceType === 'tablet') {
			return 40;
		}

		return 73;
	};
	return (
		<FractalContainer
			className='fractal-theme-response-container'
			screenSize={screenSize}
		>
			<div
				className='ff-chatbot-fractal-theme-response'
				style={{
					display: 'flex',
					flexDirection: 'column',
					paddingBottom: '30px',
				}}
			>
				{imageCards && imageCards.length !== 0 && (
					<div className='ff-suggest-heading'>{imageCards[0].heading}</div>
				)}
				<div
					className='nonp-carousel-container'
					style={{ display: 'flex', gap: '20px' }}
				>
					{imageCards && screenSize >= 800 ? (
						imageCards.map((product) => (
							<>
								<ImageCards
									readMoreUrl={product.redirectLink}
									heading={product.title}
									desc={product.reasonQuery}
									URL={product.imageURL}
									displayCardCount={imageCards.length}
								/>
							</>
						))
					) : imageCards && imageCards.length >= 2 ? (
						<div
							className='nonp-carousel'
							// style={{ display: 'flex', justifyContent: 'center' }}
						>
							<div className='ff-product-carousel-swap nonp'>
								<Carousel
									selectedItem={selectedItem}
									showArrows={true}
									showStatus={false}
									showThumbs={false}
									showIndicators={true}
									centerMode
									centerSlidePercentage={percentageCalculator()}
									width={'100%'}
									renderArrowNext={(onClickHandler, hasNext) =>
										hasNext && (
											<button
												className={`carouselButtons-swap clickable right `}
												onClick={onClickHandler}
												style={{
													top: '45%',
													right: '4px',
												}}
											>
												{/* <ArrowRight /> */}
												<ForwardFractalCarousel
													filledColor={'#0174e7'}
													fill={'#fff'}
												/>
											</button>
										)
									}
									renderArrowPrev={(onClickHandler, hasPrev) =>
										hasPrev && (
											<button
												className={`carouselButtons-swap clickable left `}
												onClick={onClickHandler}
												style={{
													top: '45%',
													left: '20px',
												}}
											>
												{/* <ArrowLeft /> */}
												<BackwardFractalCarousel
													filledColor={'#0174e7'}
													fill={'#fff'}
												/>
											</button>
										)
									}
								>
									{imageCards.map((product, index) => (
										<>
											<ImageCards
												currentClick={() => {
													setSelectedItem(index);
												}}
												readMoreUrl={product.redirectLink}
												heading={product.title}
												desc={product.reasonQuery}
												URL={product.imageURL}
												displayCardCount={imageCards.length}
											/>
										</>
									))}
								</Carousel>
							</div>
						</div>
					) : (
						<>
							{imageCards.map((product) => (
								<>
									<ImageCards
										readMoreUrl={product.redirectLink}
										heading={product.title}
										desc={product.reasonQuery}
										URL={product.imageURL}
										displayCardCount={imageCards.length}
									/>
								</>
							))}
						</>
					)}
				</div>
				<div style={{ display: 'flex', gap: '20px' }}>
					{videoCards && videoCards.length !== 0 && (
						<div
							style={{
								margin: '20px 0',
								fontWeight: '400',
							}}
						>
							{videoCards[0].heading}
						</div>
					)}
					{videoCards && videoCards.length
						? videoCards.map((product, i) => (
								<>
									<ImageCards
										readMoreUrl={product.redirectLink}
										heading={product.title}
										desc={product.reasonQuery}
										URL={product.imageURL}
										type='video'
										displayCardCount={videoCards.length}
									/>
								</>
						  ))
						: null}
				</div>
				<div style={{ display: 'flex', gap: '20px' }}>
					{textCards && textCards.length !== 0 && (
						<div
							style={{
								margin: '20px 0',
								fontWeight: '400',
							}}
						>
							{textCards[0].heading}
						</div>
					)}
					{textCards && textCards.length
						? textCards.map((product, i) => (
								<>
									<TextCards
										text={product.title}
										index={i}
										handleSubmit={submitChat}
										type={product.imageURL ? 'sources' : ''}
										redirectURL={product.imageURL}
									/>
								</>
						  ))
						: null}
				</div>
				<div style={{ display: 'flex', gap: '20px' }}>
					{podCast && podCast.length !== 0 && (
						<div
							style={{
								margin: '20px 0',
								fontWeight: '400',
							}}
						>
							{podCast[0].heading}
						</div>
					)}
					{podCast && podCast.length
						? podCast.map((product, i) => (
								<>
									{' '}
									{i === 0 ? (
										<PodCasts
											heading={product.title}
											url={product.imageURL}
											desc={product.title}
											redirectURL={product.redirectLink}
										/>
									) : null}
								</>
						  ))
						: null}
				</div>
				<div style={{ display: 'flex', gap: '20px' }}>
					{jobPostings && jobPostings.length !== 0 && (
						<div
							style={{
								margin: '20px 0',
								fontWeight: '400',
							}}
						>
							{jobPostings[0].heading}
						</div>
					)}
					{jobPostings && jobPostings.length
						? jobPostings.map((product, i) => (
								<>
									<JobPostings
										heading={product.title}
										redirectURL={product.imageURL}
										index={i}
										jobReqId='SR-11234'
										postingDate='1 week ago'
										location='Mumbai'
										timeType='Full time'
									/>
								</>
						  ))
						: null}
				</div>
			</div>
		</FractalContainer>
	);
};

export default FractalResponse;
